import { useContext } from 'react';
import { DeliveryVenueContext } from './delivery-venue-context';

const useDeliveryVenueContext = () => {
    const context = useContext(DeliveryVenueContext);

    if (context === undefined) {
        throw new Error('useDeliveryVenueContext must be within a DeliveryVenueProvider');
    }

    return context;
};

export default useDeliveryVenueContext;
